import styled from "styled-components";
import { Field as FField } from "formik";

export const Checkbox = styled(FField)``;
